module.exports = {"testApi":{"testApi":"https://tst-phd.remycn.com","api":"https://phd.remycn.com"},"api":{"testApi":"https://tst-phd.remycn.com","api":"https://dev-commonapi.indation.com"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/config.json
// module id = 2LA7
// module chunks = 0